import { PageType } from "../../constants";
import { OnboardingError } from "../../models/errors";
import { Programs } from "../../models/programsConfig";
import {
  AaaApplicationStep,
  IdXboxApplicationStep,
  PitchApplicationStep,
} from "../../models/status";
import { OnboardingRootState } from "../reducers/rootReducer";
import { getOnboardingState } from "./rootSelectors";

const getStatus = (state: OnboardingRootState) => getOnboardingState(state).status;

export const getCurrentProgram = (state: OnboardingRootState): Programs =>
  getStatus(state)?.currentProgram;

export const getCurrentPageType = (state: OnboardingRootState): PageType | undefined =>
  getStatus(state)?.currentPageType;

export const getAaaApplicationStep = (state: OnboardingRootState): AaaApplicationStep =>
  getStatus(state)?.step[Programs.Aaa] ?? AaaApplicationStep.Unset;

export const getIdXboxApplicationStep = (state: OnboardingRootState): IdXboxApplicationStep =>
  getStatus(state)?.step[Programs.IdXbox] ?? IdXboxApplicationStep.Unset;

export const getPitchApplicationStep = (state: OnboardingRootState): PitchApplicationStep =>
  getStatus(state)?.step[Programs.Pitch] ?? PitchApplicationStep.Unset;

export const getIsInitialCrmFetchDone = (state: OnboardingRootState): boolean => {
  const currentPageType = getCurrentPageType(state);
  if (!currentPageType) {
    return false;
  }
  return getIsInitialCrmFetchDoneByProgram(state, currentPageType);
};

export const getIsInitialCrmFetchDoneByProgram = (
  state: OnboardingRootState,
  pageType: PageType
): boolean => getStatus(state)?.isInitialCrmFetchDone[pageType] ?? false;

export const getCurrentError = (state: OnboardingRootState): OnboardingError | undefined =>
  getStatus(state)?.currentError;

export const getIsSavingForm = (state: OnboardingRootState): boolean =>
  getStatus(state)?.isSavingForm;

export const getIsSubmitting = (state: OnboardingRootState): boolean =>
  getStatus(state)?.isSubmitting;

export const getIsLoadingGameConcept = (state: OnboardingRootState): boolean =>
  getStatus(state)?.isLoadingGameConcept;

export const getIsCreatingXpaProgramTracking = (state: OnboardingRootState): boolean =>
  getStatus(state)?.isCreatingXpaProgramTracking;

export const getIsUpdatingXpaProgramTracking = (state: OnboardingRootState): boolean =>
  getStatus(state)?.isUpdatingXpaProgramTracking;
